<template>
    <div>
        <v-table density="compact" v-if="list_liens_vip.list.length > 0">
            <thead>
                <tr>
                    <th class="text-left">Actions</th>
                    <th class="text-left">Valide pour</th>
                    <th class="text-left">Parcours</th>
                    <th class="text-left">Options</th>
                    <th class="text-left">Activités</th>
                    <th class="text-left">Statut</th>

                    <th class="text-left">Lien</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in list_liens_vip.list" :key="item.id">
                    <td>
                        <v-btn v-if="item.actif == 1" color="error" density="compact"
                            @click="deactivate(item)">Désactiver</v-btn>
                        <v-btn v-else color="dark-green" density="compact" @click="activate(item)">Activer</v-btn>
                    </td>
  
                    <td>{{ item.nb_inscrits }} participants</td>
                    <td>
                        <div>
                            <v-chip :prepend-icon="item.doit_payer_course == 1 ? 'mdi-close' : 'mdi-check'"
                                variant="tonal" :color="item.doit_payer_course == 1 ? 'dark-red' : 'dark-green'"
                                density="compact" class="mr-2">
                                <span v-if="item.doit_payer_course == 1">Payant</span>
                                <span v-else>Gratuit</span>
                            </v-chip>
                        </div>
                        <div>
                            <span class="font-weight-bold" v-if="item.limit_acces_parcours == 1">Limité à: {{
                                list_filtered_parcours(item) }}</span>
                            <span class="font-weight-bold" v-else>Tous les parcours</span>
                        </div>
                    </td>
                    <td>
                        <v-chip :prepend-icon="item.doit_payer_option == 1 ? 'mdi-close' : 'mdi-check'" variant="tonal"
                            :color="item.doit_payer_option == 1 ? 'dark-red' : 'dark-green'" density="compact"
                            class="mr-2">
                            <span v-if="item.doit_payer_option == 1">Payant</span>
                            <span v-else>Gratuit</span>
                        </v-chip>
                        <v-chip :prepend-icon="item.acces_options_completes != 1 ? 'mdi-close' : 'mdi-check'"
                            variant="tonal" :color="item.acces_options_completes != 1 ? 'dark-red' : 'dark-green'"
                            density="compact" class="mr-2">
                            <span v-if="item.acces_options_completes == 1">complètes réservables</span>
                            <span v-else>complètes non réservables</span>
                        </v-chip>
                    </td>
                    <td>
                        <v-chip :prepend-icon="item.doit_payer_activite == 1 ? 'mdi-close' : 'mdi-check'"
                            variant="tonal" :color="item.doit_payer_activite == 1 ? 'dark-red' : 'dark-green'"
                            density="compact" class="mr-2">
                            <span v-if="item.doit_payer_activite == 1">Payant</span>
                            <span v-else>Gratuit</span>
                        </v-chip>
                        <v-chip :prepend-icon="item.acces_activites_completes != 1 ? 'mdi-close' : 'mdi-check'"
                            variant="tonal" :color="item.acces_activites_completes != 1 ? 'dark-red' : 'dark-green'"
                            density="compact" class="mr-2">
                            <span v-if="item.acces_activites_completes == 1">complètes réservables</span>
                            <span v-else>complètes non réservables</span>
                        </v-chip>
                    </td>
                    <td>
                        <v-chip v-if="item.actif == 0" color="dark-red">Inactif</v-chip>
                        <v-chip v-else-if="item.date_utilisation != '0000-00-00 00:00:00'" color="dark-red">Utilisé le
                            {{
                                $moment(item.date_utilisation).format("DD/MM/YYYY HH:mm:ss") }}</v-chip>
                        <v-chip
                            v-else-if="item.date_expiration != '0000-00-00' && $moment(item.date_expiration).isBefore($moment())"
                            color="dark-red">Expiré le {{ $moment(item.date_expiration).format("DD/MM/YYYY") }}</v-chip>
                        <v-chip
                            v-else-if="item.date_expiration != '0000-00-00' && $moment(item.date_expiration).isAfter($moment())"
                            color="dark-green">Actif jusqu'au {{ $moment(item.date_expiration).format("DD/MM/YYYY")
                            }}</v-chip>
                        <v-chip v-else-if="item.date_expiration == '0000-00-00'" color="dark-green">Actif</v-chip>
                    </td>

                    <td>
                        <v-chip variant="tonal" color="dark-green" density="compact">https://sportips.fr/inscription/{{
                            item.for_billetterie == 1 ? "BILLETTERIE_" : "" }}{{ mainStore.module.base }}?code_privilege={{
                            item.token
                            }}</v-chip>
                    </td>
                </tr>
            </tbody>
        </v-table>

        <v-alert v-else variant="tonal" color="info">Aucun lien privilégié pour ce module</v-alert>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import List_Liens_VIP from "@/classes/Lien_VIP/List_Liens_VIP.class";
export default {
    data() {
        return {
            list_liens_vip: new List_Liens_VIP(),
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        list_filtered_parcours(item) {
            return item.filter_parcours
                .filter((course) => course.selected)
                .map((course) => course.nom)
                .join(", ");
        },

        async deactivate(lien) {
            await this.list_liens_vip.deactivate(lien.id);
            this.$router.go();
        },
        async activate(lien) {
            await this.list_liens_vip.activate(lien.id);
            this.$router.go();
        },
    },
    async created() {
        this.list_liens_vip.id_module = this.mainStore.module.id;
        await this.list_liens_vip.fetch();
        this.list_liens_vip.filter_multi_usage();
    },
};
</script>

<style lang="scss" scoped></style>